<template>
  <div
    class="my-button"
    :class="customClass"
  >
    <router-link
      v-if="toName"
      :to="{ name: toName }"
      :title="title"
      class="d-flex align-center link"
    >
      <span v-html="text"></span>
      <div class="text-xs-right" v-show="is_active">
        <img src="/static/images/arrow-right.svg" alt=""/>
      </div>
    </router-link>
    <a
      v-else-if="external"
      :href="external"
      :title="title"
      class="d-flex align-center link"
    >
      <span v-html="text"></span>
      <div class="text-xs-right" v-show="is_active">
        <img src="/static/images/arrow-right.svg" alt=""/>
      </div>
    </a>

    <span class="d-flex align-center link" v-else>
      <span v-html="text"></span>
      <div class="text-xs-right" v-show="is_active">
        <img src="/static/images/arrow-right.svg" alt=""/>
      </div>
    </span>
  </div>
</template>

<script>
export default {
  props: {'toName': { type: String }, 'title': { type: String }, 'text': { type: String}, 'customClass': { type: String},  is_active: {
    type: Boolean,
    required: false,
    default: true
  }, 'external': { type: String}
  }
}
</script>

<style scoped lang="stylus">
  .no-active {
     cursor: inherit !important;
  }
  .my-button{
  cursor: pointer;
    position: relative;
    @media only screen and (min-width: 960px){
      &:before{
        content: '';
        position: absolute;
        left: 2rem;
        top: 0;
        background-color : #fff;
        height: 10px;
        width: 100px;
      }
      &:after{
        content: '';
        position: absolute;
        right: 100%;
        top: 0;
        background-color : inherit;
        height: 100%;
        width: 100%;
      }
    }
  }

  .link{
    text-decoration : none;
    color: #fff;
    display : block;
    height: 100%;
    img{
      width: 20px;
      @media only screen and (min-width: 960px){
        width: 30px;
      }
      @media only screen and (min-width: 1400px){
        width: 36px;
      }
    }
    span{
      text-transform: uppercase;
      font-weight: 700;
      font-size: 30px;
      line-height: 1;
      @media only screen and (min-width: 960px){
        font-size: 46px;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/partials/Button.vue